import { useTheme } from "@/store/theme";

export function ThemeToggle() {
  const theme = useTheme((s) => s.theme);
  const toggleTheme = useTheme((s) => s.toggleTheme);
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className="sa-theme-toggle"
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? "light" : "dark"} theme`}
      aria-pressed={isDark}
      title={`Switch to ${isDark ? "light" : "dark"} theme`}
    >
      <span className={`sa-theme-toggle__icon${isDark ? "" : " is-active"}`} aria-hidden="true">
        ☀
      </span>
      <span className={`sa-theme-toggle__icon${isDark ? " is-active" : ""}`} aria-hidden="true">
        ☾
      </span>
      <span className="sa-theme-toggle__thumb" aria-hidden="true" />
    </button>
  );
}
